<script lang="ts">
	import Modal from '$lib/components/Modal/Modal.svelte';
	import SettingsForm from '$lib/components/Post/Settings/SettingsForm.svelte';
	import { isPostSettingsModalOpen } from './settingsModalStore';
	import { _ } from 'svelte-i18n';
	// For some reason I was not able to make the form reactive unless its in its own component (using onMount)
</script>

{#if $isPostSettingsModalOpen}
	<Modal onClose={() => ($isPostSettingsModalOpen = false)} isOpen={$isPostSettingsModalOpen}>
		<div slot="title">
			{$_('post.menu.settings')}
		</div>
		<div slot="content">
			<SettingsForm />
		</div>
	</Modal>
{/if}
